import { Instagram } from "@mui/icons-material";
import {
  Divider,
  Grid,
  Skeleton,
} from "@mui/material";
import { useMediaQuery, useTheme } from "@mui/system";
import { debounce } from "lodash";
import React, { useCallback, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import BlogMain from "../../assets/images/FrankIcons/blog-main.png";
import apiServices from "../../services/RequestHandler";
import CustomButton from "../../UiComponent/CustomButton";
import CustomFooter from "../../UiComponent/CustomFooter";
import Loader from "../../UiComponent/Loader";
import NewHeader from "../../UiComponent/NewHeader";
import { defaultLabelColors } from "../../utils/constants";
import { handleLocalize, useResponsiveValue1024 } from "../../utils/helper";
import "moment/locale/fr"; // Import French locale
import CustomMobileFooter from "../../UiComponent/CustomMobileFooter";
import MobileResponsive from "../LandingPage/MobileResponsive";
import BlogsComponent from "./BlogsComponent";

// interface InstagramPost {
//   id: string;
//   media_url: string;
//   caption: string;
// }
function Blogs(props: any) {
  const navigate = useNavigate();
  const [state, setState] = React.useReducer(
    (state: any, newState: any) => ({ ...state, ...newState }),
    {
      activity: false,
      page: 1,
    }
  );
  const theme = useTheme();

  const screen_1024 = useMediaQuery(theme.breakpoints.up(1025));
  const screen_600 = useMediaQuery(theme.breakpoints.up(601));

  

  const getInstaPost = async () => {
    try {
      setState({ activity: true });
      let resp = await apiServices.getFromApi("c2c-blogs/insta-posts", "");
      setState({ instaPosts: resp?.data, activity: false });
    } catch (error) {}
  };

  React.useEffect(() => {
    handleGetAllCategory();
    handleGetAllBlog();
    getInstaPost();
    // eslint-disable-next-line
  }, []);

  const handleGetAllCategory = async () => {
    try {
      setState({ activity: true });

      let resp = await apiServices.getFromApi("c2c-blog-categories/web", "");
      if (resp?.status === 200 || resp?.status === 201) {
        setState({ allCategories: resp?.data });
        setState({ activity: false });
      }
    } catch (error) {
      console.log(error);
      setState({ activity: false });
    }
  };

  // const onInputChange = (e: any) => {
  //   try {
  //     const { value, name } = e.target;
  //     setState({
  //       [name]: value,
  //     });
  //   } catch (error) {}
  // };

  useEffect(() => {
    handleGetAllBlog();
    // eslint-disable-next-line
  }, []);

  const handleGetAllBlog = async () => {
    try {
      setState({ activity: true });
      let resp = await apiServices.getFromApi(
        `c2c-blogs/web?page=${state?.page}&limit=6`,
        ""
      );
 
      if (resp?.status === 200 || resp?.status === 201) {
        setState({
          allBlogs: resp?.data,
          totalPage: resp?.total_pages,
          BlogById: resp?.data,
        });
        setState({ activity: false });
      }
    } catch (error) {
      setState({ activity: false });
    }
  };
  const handleGetBlogById = async (idd: number) => {
    try {
      setState({ activity: true });
      let resp = await apiServices.getFromApi(`c2c-blogs/web/${idd}`, "");

      if (resp?.status === 200 || resp?.status === 201) {
        setState({ BlogById: resp?.data });
        setState({ activity: false });
      }
    } catch (error) {
      setState({ activity: false });
    }
  };

  // eslint-disable-next-line
  const handleSearchProducts = useCallback(
    debounce(async (searchValue: any) => {
      try {
        if (!searchValue) {
          setState({ activity: true });
          handleGetAllBlog();
          setState({
            activity: false,
          });
        }
        if (searchValue?.trim()) {
          setState({ activity: true });
          let resp = await apiServices.getFromApi(
            `c2c-blogs/web?search=${searchValue}`,
            ""
          );
          if (resp?.data?.length < 1) {
            setState({
              showImg: true,
            });
          }
          setState({
            allBlogs: resp?.data,
            activity: false,
            showSearchedData: true,
          });
        }
      } catch (error) {
        console.error("Error while searching products:", error);
      }
    }, 1500),
    []
  );

  useEffect(() => {
    handleSearchProducts(state.global_search);
  }, [state.global_search, handleSearchProducts]);

  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);

 

  return (
    <>
      <Loader loading={state?.activity} />

      <Helmet>
        <title>
          Blogs | Articles et Conseils sur la Livraison Collaborative
        </title>
        <link rel="canonical" href="https://www.frank.fr/blogs" />
        <meta
          name="description"
          content="Découvrez nos articles et conseils sur la livraison collaborative, des témoignages de la communauté Frank, et des astuces pour optimiser vos envois."
        />
      </Helmet>
      <div
        className="web-screen"
        style={{ background: defaultLabelColors?.main_background_new }}
      >
        <div
          style={{
            background: defaultLabelColors.main_background_new,
            justifyItems: "center",
            display: "flex",
            justifyContent: "center",
          }}
        >
          {/* <ScrollToTop /> */}


          <div
            style={{
              maxWidth: 1408,
              width: "100%",
            }}
          >
            <NewHeader />
            <div
              style={{
                background: defaultLabelColors?.main_background_new,
                // paddingTop: "80px",
                // paddingBottom: "80px",
                // paddingLeft: 50,

                // paddingRight: 50,
                padding:screen_1024 ? "80px 50px":"20px 16px",

                marginTop: 80,
              }}
            >
              <div style={{ display: "flex", justifyContent: useResponsiveValue1024("space-between",""),flexDirection:useResponsiveValue1024("row","column-reverse") }}>
                <div style={{ width: useResponsiveValue1024("479px","100%") }}>
                  <div style={{ width: useResponsiveValue1024("80%","100%") }}>
                    <h1 className="montserrat-Regular" style={{fontSize:useResponsiveValue1024("40px","22px")}}>
                      {handleLocalize(state?.allBlogs?.[0]?.title)}
                    </h1>
                  </div>

                  <div>
                    <CustomButton
                      style={{
                        width: "max-content",
                        padding: screen_1024 ? "9px 21px":"7px 16px",
                      }}
                      onClick={() => {
                        navigate(
                          `/blog-details/${state?.allBlogs?.[0]?.blog_cat_id}/${state?.allBlogs?.[0]?.id}`
                        );
                      }}
                      classesNames={"new_contained_button"}
                      value={
                        <React.Fragment>
                          <div
                            className="display-flex"
                            style={{
                              columnGap: "10px",
                              // padding: "5px 0px 5px 0px",
                              height: 24,
                              fontSize: screen_1024 ? "16px":"14px",
                            }}
                          >
                            En savoir plus{" "}
                          </div>
                        </React.Fragment>
                      }
                    />
                  </div>
                </div>

                <div style={{ width: useResponsiveValue1024("60%","100%"), height: 452, borderRadius: 24 }}>
                  {state?.allBlogs?.[0]?.blog_image ? (
                    <img
                      style={{
                        height: "100%",
                        width: "100%",
                        borderRadius: 24,
                        objectFit: "cover",
                      }}
                      alt="not-found"
                      src={
                        state?.allBlogs?.[0]?.blog_image?.[1] ??
                        state?.allBlogs?.[0]?.blog_image?.[0] ??
                        BlogMain
                      }
                    />
                  ) : (
                    <Skeleton
                      animation="wave"
                      variant="rectangular"
                      width={"100%"}
                      height={452}
                      accessKey=""
                      sx={{ borderRadius: "24px" }}
                    />
                  )}
                </div>
              </div>

              <div style={{ paddingTop: "46px" }}>
                <Divider
                  sx={{ background: "#BCBBC4", color: "#BCBBC4", height: 1 }}
                ></Divider>
              </div>

              <div>
                <Grid
                  container
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                  }}
                >
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <h2
                      style={{
                        textAlign: "left",
                        fontSize: "28px",
                        padding: "40px 0px 30px 0px",
                        margin: 0,
                        color: "#000",
                      }}
                      className="montserrat-Bold"
                    >
                      Actualités
                    </h2>
                    <ul className="cards">
                      {/* <Grid container spacing={3}>
                        {state?.allBlogs?.slice(0, 3)?.map((item: any) => {
                          return (
                            <>
                              <Grid
                                xs={12}
                                sm={6}
                                md={screen_1024 ? 4 : 6}
                                // className="cards__item"
                                item
                                style={{
                                  display: "flex",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  navigate(
                                    `/blog-details/${item?.blog_cat_id}/${item?.id}`
                                  );
                                }}
                              >
                                <div className="card">
                                  <CardMedia
                                    component="img"
                                    style={{
                                      minHeight: screen_1024 ? 296 : 220,
                                      objectFit: "cover",
                                      borderRadius: 8,
                                    }}
                                    image={
                                      item?.blog_image?.[1] ??
                                      item?.blog_image?.[0]
                                    } // Replace with the image URL you need
                                    alt="Blog card image"
                                  />
                                  <div
                                    className="card__content"
                                    style={{ gap: 10 }}
                                  >
                                    <div style={{ display: "flex" }}>
                                      <div
                                        className="card__title"
                                        style={{ flex: 1 }}
                                      >
                                        {handleLocalize(item?.title)}
                                      </div>
                                    </div>
                                    <p
                                      className="card__text"
                                      style={{ margin: 0, maxLines: 4 ,display:screen_1024 ? "block":"none"}}
                                    >
                                      {handleLocalize(item?.sub_title)}
                                    </p>
                                    <p
                                      style={{
                                        fontSize: screen_1024 ? "16px":"12px",
                                        color: "#78778A",
                                        fontWeight: "400",
                                        margin: 0,
                                      }}
                                      className="montserrat-Regular"
                                    >
                                      {moment(
                                        `${item?.created_at}`.endsWith("Z")
                                          ? item?.created_at
                                          : item?.created_at + "Z"
                                      ).format("DD MMMM YYYY")}{" "}
                                      <span
                                        style={{
                                          fontFamily: "montserrat-SemiBold",
                                          textDecoration: "underline",
                                          color: "#000",
                                          paddingLeft: 5,
                                          display:screen_1024 ? "block":"none"
                                        }}
                                      >
                                        {handleLocalize(item?.category_name)}
                                      </span>
                                    </p>
                                    <div style={{
                                      display:screen_1024 ? "block":"none"
                                    }}>
                                      <CustomButton
                                        style={{
                                          padding:"9px 21px",

                                        }}
                                        onClick={() => {
                                          // navigate("/transporter-un-colis");
                                          navigate(
                                            `/blog-details/${item?.blog_cat_id}/${item?.id}`
                                          );
                                        
                                        }}
                                        classesNames={"new_contained_button"}
                                        value={"En savoir plus"}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </Grid>
                            </>
                          );
                        })}
                      </Grid> */}
                                          <BlogsComponent allBlogs={state?.allBlogs}/>

                    </ul>
                  </div>
                </Grid>
              </div>

              <div style={{ padding: "30px 20px 20px 0px",display:"flex",flexDirection:"column",gap:"30px" }}>
                <h2 style={{ fontFamily: "montserrat-Bold", fontSize: useResponsiveValue1024("28px","22px"),margin:0 }}>
                  {" "}
                  Actualités par sujet
                </h2>
                <div style={{ display: "flex", flexFlow: "wrap", gap: "10px" }}>
                  {state?.allCategories?.slice?.(0, 6)?.map((category: any) => {
                    const isSelected = selectedCategory === category?.id;

                    return (
                      <div
                        className="responsive-button-wrapper"
                        key={category?.id}
                      >
                        <CustomButton
                          value={handleLocalize({
                            en: category?.category_name?.en,
                            fr: category?.category_name?.fr,
                          })}
                          classesNames="toggle_outlined_button_tab"
                          
                          onClick={() => {
                            setSelectedCategory(category?.id); // toggle logic (one active at a time)
                            handleGetBlogById(Number(category?.id));
                          }}
                          style={{
                            border: isSelected
                              ? "1px solid #000"
                              : "1px solid #BCBBC4",
                            borderRadius: "100px",
                          }}
                        />
                      </div>
                    );
                  })}
                </div>
              </div>

              <div style={{ display: "flex", flexDirection: "column" }}>
                <ul className="cards">
                  {/* <Grid container spacing={3}>
                    {state?.BlogById?.slice(0, 3)?.map((item: any) => {
                      return (
                        <>
                          <Grid
                            item
                            xs={12}
                            sm={6}
                            md={screen_1024 ? 4 : 6}
                            // className="cards__item"
                            style={{
                              display: "flex",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              navigate(
                                `/blog-details/${item?.blog_cat_id}/${item?.id}`
                              );
                            }}
                          >
                            <div className="card">
                              <CardMedia
                                component="img"
                                style={{
                                  minHeight: screen_1024 ? 296 : 220,
                                  objectFit: "cover",
                                  borderRadius: 8,
                                }}
                                image={
                                  item?.blog_image?.[1] ?? item?.blog_image?.[0]
                                } // Replace with the image URL you need
                                alt="Blog card image"
                              />
                              <div
                                className="card__content"
                                style={{ gap: 10 }}
                              >
                                <div style={{ display: "flex" }}>
                                  <div
                                    className="card__title"
                                    style={{ flex: 1 }}
                                  >
                                    {handleLocalize(item?.title)}
                                  </div>
                                </div>
                                <p
                                  className="card__text"
                                  style={{ margin: 0, maxLines: 4 ,display:screen_1024 ? "block":"none"}}
                                >
                                  {handleLocalize(item?.sub_title)}
                                </p>
                                <p
                                  style={{
                                    fontSize: screen_1024 ? "16px":"12px",

                                    color: "#78778A",
                                    fontWeight: "400",
                                    margin: 0,
                                  }}
                                  className="montserrat-Regular"
                                >
                                  {moment(
                                    `${item?.created_at}`.endsWith("Z")
                                      ? item?.created_at
                                      : item?.created_at + "Z"
                                  ).format("DD MMMM YYYY")}{" "}
                                  <span
                                    style={{
                                      fontFamily: "montserrat-SemiBold",
                                      textDecoration: "underline",
                                      color: "#000",
                                      paddingLeft: 5,
                                      display:screen_1024 ? "block":"none"
                                    }}
                                  >
                                    {handleLocalize(item?.category_name)}
                                  </span>
                                </p>
                                <div 
                                style={{
                                  display:screen_1024 ? "block":"none"
                                }}
                                >
                                  <CustomButton
                                    style={{
                                      padding:"9px 21px",

                                    }}
                                    onClick={() => {
                                      // navigate("/transporter-un-colis");
                                      navigate(
                                        `/blog-details/${item?.blog_cat_id}/${item?.id}`
                                      );
                                  
                                    }}
                                    classesNames={"new_contained_button"}
                                    value={"En savoir plus"}
                                  />
                                </div>
                              </div>
                            </div>
                          </Grid>
                        </>
                      );
                    })}
                  </Grid> */}
                    <BlogsComponent allBlogs={state?.BlogById}/>

                </ul>
              </div>

              <div style={{ padding: "28px 0px " }}>
                <Divider
                  color="#E9E8EB"
                  sx={{
                    "&::before, &::after": {
                      color: "#E9E8EB",
                    },
                    borderWidth: "1px",
                  }}
                ></Divider>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  fontSize: "22px",
                  color: "black",
                  padding: "20px 0px",
                  gap: 6,
                  fontFamily: "montserrat-Bold",

                }}
              >
                <Instagram
                  style={{
                    fontSize: "32px",
                    fontWeight: "400",
                    color: "black",
                    fontFamily: "montserrat-Bold",
                  }}
                />{" "}
                Instagram
              </div>
              <div>
                <Grid container spacing={3} className="gallery">
                  {state?.instaPosts?.slice(0, 3)?.map((i: any) => {
                    return (
                      <Grid
                        // xs={6}
                        md={4}
                        sm={4}
                        item
                        // className="gallery-item"
                        onClick={() =>
                          window.open(
                            "https://www.instagram.com/frankme.fr/",
                            "_blank",
                            "noopener,noreferrer"
                          )
                        }
                        style={{ cursor: "pointer" }}
                      >
                        <img
                          src={
                            i?.media_type === "VIDEO"
                              ? i?.thumbnail_url
                              : i?.media_url
                          }
                          alt=""
                          style={{
                            borderRadius: "2px",
                            height: screen_1024?"554px" :"238px",
                            width: screen_1024?"426px":"189px",
                            objectFit: "cover",
                            maxWidth: "100%",
                          }}
                        />
                      </Grid>
                    );
                  })}
                </Grid>
              </div>
            </div>
          </div>
        </div>

      
        {screen_1024 ? (
          <div className="main-container"
          style={{
            background: defaultLabelColors?.main_background_new,
            zIndex: 1,
          }}
          >
            <CustomFooter />
          </div>
        ) : screen_600 ? (
          <CustomMobileFooter />
        ) : null}
      </div>
     <div className="mobile-screen">
      <MobileResponsive/>
     </div>
    </>
  );
}

export default Blogs;
